import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Restaumatic$dOldStorage from "../Restaumatic.OldStorage/index.js";
import * as Restaumatic$dOrders$dTypes$dDineInLocation from "../Restaumatic.Orders.Types.DineInLocation/index.js";
const readSessionStoredValue = /* #__PURE__ */ Restaumatic$dOldStorage.readSessionStoredValue(Restaumatic$dOrders$dTypes$dDineInLocation.decodeDineInLocation)();
const readDineInLocation = dictMonadReader => {
  const readSessionStoredValue1 = readSessionStoredValue(dictMonadReader);
  return dictMonadEffect => readSessionStoredValue1(dictMonadEffect)("initialDineInLocation");
};
const isDineInOrder = dictMonadReader => {
  const readSessionStoredValue1 = readSessionStoredValue(dictMonadReader);
  return dictMonadEffect => dictMonadEffect.Monad0().Bind1().Apply0().Functor0().map(Data$dMaybe.isJust)(readSessionStoredValue1(dictMonadEffect)("initialDineInLocation"));
};
export {isDineInOrder, readDineInLocation, readSessionStoredValue};
